import { gql } from 'apollo-boost';

export const GET_REPORT_BY_PUBLISHER = gql`
query reportByPublisherByRangeDate($dateStart: String!, $dateEnd: String!) {
    reportByPublisherByRangeDate(dateStart: $dateStart, dateEnd: $dateEnd) {
        ctr
        cpm
        impressions
        publisherId
        revenue
        rpm
        viewability
    }
  }
`;

export const GET_REPORT_BY_DATE = gql`
  query reportByDate($dateStart: String!, $dateEnd: String!, $publishers: [String!]) {
  reportByDate(dateStart: $dateStart, dateEnd: $dateEnd, publishers: $publishers) {
        date
        ctr
        cpm
        impressions
        revenue
        rpm
        viewability
    }
  }
`;

export const GET_REPORT_BY_PUBLISHER_PAYMENT = gql`
query reportByPublisherByRangeDatePayment($month: Float!, $year: Float!) {
  reportByPublisherByRangeDatePayment(month: $month, year: $year) {
    revenue
    publisherId
    }
  }
`;


export const GET_RECEIVED_PAYMENTS_BY_PUBLISHER = gql`
query reportByPublisherByRangeDate($publisherId: String!) {
    reportByPublisherByRangeDate(publisherId: $publisherId) {
        id
        referenceDate
        paymentDate
        paymentValue
        receipt
    }
  }
`;
